import React from "react";
import {useTranslation} from "react-i18next";
import {FieldArray} from "formik";
import {Grid} from "@mui/material";
import {StyledButton} from "../../../ui-base/button";
import {StyledInput} from "../../../form/input";
import {IconButton} from "@material-ui/core";
import {CustomTrashIcon} from "../../../ui-base/icons/custom-trash-icon";
import styled from "styled-components";
import {LanguageAutocomplete} from "../../../form/language-autocomplete";

export const TranslateLangToLang: React.FC<Props> = (
	{values, fieldName, handleChange, errors, touched, setFieldValue}
) => {
	const { t } = useTranslation('publisher');

	return (
		<StyledWrapper item container direction={"column"}>
			<FieldArray name={fieldName}>
				{({ remove, push }) => (
					<Grid container direction="column" spacing={1}>
						{values[fieldName]?.length > 0 && values[fieldName].map((value, index) => {
							return <Grid key={index} item container direction="row" spacing={1}>
								<Grid item xs>
									<LanguageAutocomplete
										value={values[fieldName][index].fromLang}
										setFieldValue={setFieldValue}
										fieldName={`${fieldName}.${index}.fromLang`}
										label={t('translateLangToLang.fromLang')}
										handleChange={handleChange}
										error={false}
										multiple={false}
									/>
									{/*<StyledInput*/}
									{/*	id={`${fieldName}.${index}.fromLang`}*/}
									{/*	label={t('translateLangToLang.fromLang')}*/}
									{/*	onChange={handleChange}*/}
									{/*	value={values.title}*/}
									{/*	error={errors.title && touched.title}*/}
									{/*/>*/}
								</Grid>

								<Grid item xs>
									<LanguageAutocomplete
										value={values[fieldName][index].toLang}
										setFieldValue={setFieldValue}
										fieldName={`${fieldName}.${index}.toLang`}
										label={t('translateLangToLang.toLang')}
										handleChange={handleChange}
										error={false}
										multiple={false}
									/>
									{/*<StyledInput*/}
									{/*	id={`${fieldName}.${index}.toLang`}*/}
									{/*	label={t('translateLangToLang.toLang')}*/}
									{/*	onChange={handleChange}*/}
									{/*	value={values.title}*/}
									{/*	error={errors.title && touched.title}*/}
									{/*/>*/}
								</Grid>

								<Grid item sm={"auto"} md={1} container direction={"row"} alignItems={"center"} justifyContent={"center"} style={{flexGrow: 0}}>
									<IconButton aria-label="delete" onClick={() => {
										remove(index);
									}}>
										<CustomTrashIcon style={{fill: 'transparent'}}/>
									</IconButton>
								</Grid>
							</Grid>
						})}

						<Grid item xs={12}>
							<StyledButton type="button" color={"transparentViolet"} onClick={() => {
								push({fromLang: '', toLang: ''});
							}}>
								{t('translateLangToLang.add')}
							</StyledButton>
						</Grid>
					</Grid>
				)}
			</FieldArray>
		</StyledWrapper>
	)
}

interface Props {
	values: any,
	fieldName: any,
	handleChange: any,
	errors?: any,
	touched?: any,
	setFieldValue: any
}

const StyledWrapper = styled(Grid)`
  padding-left: 20px;
  padding-bottom: 10px;
`;
